// extracted by mini-css-extract-plugin
module.exports = {"sortPanel":"SortPanel_sortPanel__21bcN","sortGroup":"SortPanel_sortGroup__1I5xp","sortingType":"SortPanel_sortingType__22D3R"};